"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const errorResponseTransformer_1 = __importDefault(require("../../Util/errorResponseTransformer"));
const exception_1 = require("@almservices-cl/exception");
const AuthException_1 = __importDefault(require("../../Exception/AuthException"));
const uuidv4_1 = __importDefault(require("../../Util/uuidv4"));
const RuntimeException_1 = __importDefault(require("../../Exception/RuntimeException"));
class Client {
    constructor(requestExecutor, logger, clientId = "", clientSecret = "") {
        this.oauthUrl = "/oauth/v2/token";
        this.interceptors = [];
        this.logIn = async (credentials) => {
            const params = `grant_type=password&client_id=${this.clientId}&client_secret=${this.clientSecret}&username=${encodeURIComponent(credentials.login)}&password=${encodeURIComponent(credentials.password)}`;
            const request = {
                url: this.oauthUrl,
                method: "post",
                data: params,
                headers: {
                    "content-type": "application/x-www-form-urlencoded",
                },
                id: (0, uuidv4_1.default)(),
            };
            try {
                const data = await this.requestExecutor.execute(request);
                if (data === undefined || data.access_token === undefined) {
                    throw new exception_1.NetworkException("no response data returned");
                }
                return {
                    token: data.access_token,
                    refreshToken: data.refresh_token,
                    expiresIn: data.expires_in,
                };
            }
            catch (e) {
                if (e instanceof Error) {
                    throw (0, errorResponseTransformer_1.default)(e);
                }
                throw new RuntimeException_1.default("Request ended with uncaught runtime exception");
            }
        };
        this.refreshToken = async (refreshToken) => {
            const params = `grant_type=refresh_token&client_id=${this.clientId}&client_secret=${this.clientSecret}&refresh_token=${refreshToken}`;
            const request = {
                url: this.oauthUrl,
                method: "post",
                data: params,
                headers: {
                    "content-type": "application/x-www-form-urlencoded",
                },
                id: (0, uuidv4_1.default)(),
            };
            try {
                const data = await this.requestExecutor.execute(request);
                return {
                    token: data.access_token,
                    refreshToken: data.refresh_token,
                    expiresIn: data.expires_in,
                };
            }
            catch (e) {
                if (e instanceof Error) {
                    throw (0, errorResponseTransformer_1.default)(e);
                }
                throw new RuntimeException_1.default("Request ended with uncaught runtime exception");
            }
        };
        this.get = async (url, body, 
        // eslint-disable-next-line @typescript-eslint/ban-types
        options = {}, headers = {}, intercept = true) => {
            let request = {
                data: body,
                method: "get",
                url,
                headers: headers,
                options,
                id: (0, uuidv4_1.default)(),
            };
            return this.retryOnAuth(async () => {
                if (intercept) {
                    for (const interceptor of this.interceptors) {
                        request = await interceptor.intercept(request);
                    }
                }
                try {
                    return await this.requestExecutor.execute(request);
                }
                catch (e) {
                    if (e instanceof Error) {
                        throw (0, errorResponseTransformer_1.default)(e);
                    }
                    throw new RuntimeException_1.default("Request ended with uncaught runtime exception");
                }
            });
        };
        this.post = async (url, body, intercept = true, headers = {
            "Content-Type": "application/json",
        }) => {
            return this.retryOnAuth(async () => {
                this.logger.log(`Request to ${url}`);
                let request = {
                    method: "post",
                    url,
                    data: body,
                    headers,
                    id: (0, uuidv4_1.default)(),
                };
                if (intercept) {
                    for (const interceptor of this.interceptors) {
                        request = await interceptor.intercept(request);
                    }
                }
                try {
                    return await this.execute(request);
                }
                catch (e) {
                    if (e instanceof Error) {
                        throw (0, errorResponseTransformer_1.default)(e);
                    }
                    throw new RuntimeException_1.default("Request ended with uncaught runtime exception");
                }
            });
        };
        this.execute = async (clientRequest) => {
            return this.requestExecutor.execute(clientRequest);
        };
        this.retryOnAuth = async (action) => {
            try {
                return await action();
            }
            catch (e) {
                if (e instanceof AuthException_1.default) {
                    this.logger.log("retry on request");
                    return await action();
                }
                throw e;
            }
        };
        this.delete = (url, body, options = {}, headers = {}, intercept = true) => {
            let request = {
                data: body,
                method: "delete",
                url,
                headers: headers,
                options,
                id: (0, uuidv4_1.default)(),
            };
            return this.retryOnAuth(async () => {
                if (intercept) {
                    for (const interceptor of this.interceptors) {
                        request = await interceptor.intercept(request);
                    }
                }
                try {
                    return await this.requestExecutor.execute(request);
                }
                catch (e) {
                    if (e instanceof Error) {
                        throw (0, errorResponseTransformer_1.default)(e);
                    }
                    throw new RuntimeException_1.default("Request ended with uncaught runtime exception");
                }
            });
        };
        this.requestExecutor = requestExecutor;
        this.logger = logger;
        this.clientId = clientId;
        this.clientSecret = clientSecret;
    }
    registerInterceptor(interceptor) {
        this.interceptors.push(interceptor);
    }
}
exports.default = Client;
//# sourceMappingURL=Client.js.map